module.exports = __webpack_public_path__ + "static/media/chidera.c3be8891.jpg";